export default __webpack_public_path__ + "static/media/gallery_07.c8adb42f.jpg";